module.exports = __webpack_public_path__ + "static/img/undo.51bf9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/undo.png
// module id = wHMR
// module chunks = 0